// extracted by mini-css-extract-plugin
export default {"wrapper":"NativeSelect_wrapper__IvHHM","select":"NativeSelect_select__YnVla","placeholder":"NativeSelect_placeholder__dGg+V","icon":"NativeSelect_icon__Dlh+D"};